$(function () {
    // any validation summary items should be encapsulated by a class alert and alert-danger
    $('.validation-summary-errors').each(function () {
        $(this).addClass('alert');
        $(this).addClass('alert-danger');
    });

    // update validation fields on submission of form
    $('form').has("[data-val=true]").on("submit", function () {

        if ($(this).valid()) {
            $(this).find('div.form-group').each(function () {
                if ($(this).find('span.field-validation-error').length == 0) {
                    $(this).removeClass('has-error');
                }
            });
        }
        else {
            $(this).find('div.form-group').each(function () {
                if ($(this).find('span.field-validation-error').length > 0) {
                    $(this).addClass('has-error');
                }
            });
            $('.validation-summary-errors').each(function () {
                if ($(this).hasClass('alert-danger') == false) {
                    $(this).addClass('alert');
                    $(this).addClass('alert-danger');
                }
            });
        }
    });


    // add has-error class to form groups with errors after postback
    $('form').each(function () {
        $(this).find('div.form-group').each(function () {
            if ($(this).find('span.field-validation-error').length > 0) {
                $(this).addClass('has-error');
            }
        });
    });



});

$.validator.unobtrusive.options = {
    errorClass: "text-danger2"
};

$.validator.setDefaults({
    highlight: function (element) {
        $(element).closest(".form-group").addClass("has-error");
    },
    unhighlight: function (element) {
        $(element).closest(".form-group").removeClass("has-error");
    }

});


$.validator.addMethod('required_true', function (value, element, param) {
    // check if dependency is met
    if (!this.depend(param, element)) {
        return "dependency-mismatch";
    }
    if (element.nodeName.toLowerCase() === "select") {
        // could be an array for select-multiple or a string, both are fine this way
        var val = $(element).val();
        return val && val.length > 0;
    }
    else if (element.nodeName.toLowerCase() === "input") {
        return value && value.toLowerCase() === "true";
    }

    if (this.checkable(element)) {
        return this.getLength(value, element) > 0;
    }
    return $.trim(value).length > 0;
});

$.validator.unobtrusive.adapters.addBool("mandatory", "required_true");

// we add a custom jquery validation method
$.validator.addMethod('requireone', function (value, element, other) {

    // hijack the built-in "required" validator method to
    var me = $.validator.methods.required.call(this, this.elementValue(element), element, true);
    var him = $.validator.methods.required.call(this, this.elementValue(other), other, true);

    if (this.settings.onfocusout) {
        $(other).unbind(".validate-requireone").bind("blur.validate-requireone", function () {
            $(element).valid();
        });
    }

    return (me && !him) || (!me && him);
}, '');

$.validator.addMethod('requireeither', function (value, element, other) {

    // hijack the built-in "required" validator method to
    var me = $.validator.methods.required.call(this, this.elementValue(element), element, true);
    var him = $.validator.methods.required.call(this, this.elementValue(other), other, true);

    if (this.settings.onfocusout) {
        $(other).unbind(".validate-requireeither").bind("blur.validate-requireeither", function () {
            $(element).valid();
        });
    }

    return (me || him);
}, '');

// and an unobtrusive adapter
$.validator.unobtrusive.adapters.add('requireone', ["other"], function (options) {

    var prefix = options.element.name.substr(0, options.element.name.lastIndexOf(".") + 1);
    var other = options.params.other;
    if (other.indexOf("*.") === 0) {
        other = other.replace("*.", prefix);
    }

    element = $(options.form).find(":input[name=" + other + "]")[0];

    options.rules["requireone"] = element;
    if (options.message) {
        options.messages["requireone"] = options.message;
    }

});

$.validator.unobtrusive.adapters.add('requireeither', ["other"], function (options) {

    var prefix = options.element.name.substr(0, options.element.name.lastIndexOf(".") + 1);
    var other = options.params.other;
    if (other.indexOf("*.") === 0) {
        other = other.replace("*.", prefix);
    }

    element = $(options.form).find(":input[name=" + other + "]")[0];

    options.rules["requireeither"] = element;
    if (options.message) {
        options.messages["requireeither"] = options.message;
    }

});

$.validator.addMethod('requireotherif',
    function (value, element, parameters) {
        // get the target value (as a string,
        // as that's what actual value will be)
        var targetvalue = parameters['targetvalue'];
        targetvalue =
          (targetvalue == null ? '' : targetvalue).toString().toLowerCase();

        var actualvalue = value.toString().toLowerCase();

        if (actualvalue === targetvalue) {
            var target = $(element.form).find(":input[name=" + parameters['requiredproperty'] + "]");
            return $.validator.methods.required.call(
              this, this.elementValue(target[0]), target[0], parameters);
        }

        return true;
    }
);
//$.validator.addMethod('datetime',
//    function (value, element, params) {
//        return this.optional(element) || /^\d{4}[\/-]\d{2}[\/-]\d{2}\s*(?:\d{2}:\d{2}(?::\d{2})?)?$/.test(value);
//    }
// );

//$.validator.unobtrusive.adapters.addBool('datetime');

$.validator.unobtrusive.adapters.add(
    'requireotherif',
    ['requiredproperty', 'targetvalue'],
    function (options) {
        options.rules['requireotherif'] = {
            requiredproperty: options.params['requiredproperty'],
            targetvalue: options.params['targetvalue']
        };
        options.messages['requireotherif'] = options.message;
    });

$.validator.addMethod('requireotherifnot',
    function (value, element, parameters) {
        // get the target value (as a string,
        // as that's what actual value will be)
        var targetvalue = parameters['targetvalue'];
        targetvalue =
          (targetvalue == null ? '' : targetvalue).toString().toLowerCase();

        var actualvalue = value.toString().toLowerCase();

        if (actualvalue !== targetvalue) {
            var target = $(element.form).find(":input[name=" + parameters['requiredproperty'] + "]");
            return $.validator.methods.required.call(
              this, this.elementValue(target[0]), target[0], parameters);
        }

        return true;
    }
);

$.validator.unobtrusive.adapters.add(
    'requireotherifnot',
    ['requiredproperty', 'targetvalue'],
    function (options) {
        options.rules['requireotherifnot'] = {
            requiredproperty: options.params['requiredproperty'],
            targetvalue: options.params['targetvalue']
        };
        options.messages['requireotherifnot'] = options.message;
    });

$.validator.addMethod('requiredif',
    function (value, element, parameters) {

        // get the target value (as a string,
        // as that's what actual value will be)
        var targetvalue = parameters['targetvalue'];
        targetvalue =
          (targetvalue == null ? '' : targetvalue).toString().toLowerCase();

        // get the first input with the right name, and then it's type
        var control = $(element.form).find(":input[name=" + parameters['dependentproperty'] + "]");
        var controltype = control.attr('type');

        // get the actual value of the target control
        var actualvalue = "";
        if (controltype === 'radio') {
            var checked = $(element.form).find(":input[name=" + parameters['dependentproperty'] + "]:checked");
            if (checked.length > 0) {
                actualvalue = checked.val();
            }
        } else if (controltype === 'checkbox') {
            actualvalue = control.prop('checked');
        }
        else {
            actualvalue = control.val();
        }

        actualvalue = actualvalue.toString().toLowerCase();

        // if the condition is true, reuse the existing
        // required field validator functionality
        if (targetvalue === actualvalue)
            return $.validator.methods.required.call(
              this, value, element, parameters);

        return true;
    }
);

$.validator.unobtrusive.adapters.add(
    'requiredif',
    ['dependentproperty', 'targetvalue'],
    function (options) {
        options.rules['requiredif'] = {
            dependentproperty: options.params['dependentproperty'],
            targetvalue: options.params['targetvalue']
        };
        options.messages['requiredif'] = options.message;
    });


$.validator.addMethod('mandatoryif',
    function (value, element, parameters) {

        // get the target value (as a string,
        // as that's what actual value will be)
        var targetvalue = parameters['targetvalue'];
        targetvalue =
            (targetvalue == null ? '' : targetvalue).toString().toLowerCase();

        // get the first input with the right name, and then it's type
        var control = $(element.form).find(":input[name=" + parameters['dependentproperty'] + "]");
        var controltype = control.attr('type');

        // get the actual value of the target control
        var actualvalue = "";
        if (controltype === 'radio') {
            var checked = $(element.form).find(":input[name=" + parameters['dependentproperty'] + "]:checked");
            if (checked.length > 0) {
                actualvalue = checked.val();
            }
        } else if (controltype === 'checkbox') {
            actualvalue = control.prop('checked');
        }
        else {
            actualvalue = control.val();
        }

        actualvalue = actualvalue.toString().toLowerCase();

        // if the condition is true, reuse the existing
        // required field validator functionality
        if (targetvalue === actualvalue)
            return $.validator.methods.required_true.call(
                this, value, element, parameters);

        return true;
    }
);

$.validator.unobtrusive.adapters.add(
    'mandatoryif',
    ['dependentproperty', 'targetvalue'],
    function (options) {
        options.rules['mandatoryif'] = {
            dependentproperty: options.params['dependentproperty'],
            targetvalue: options.params['targetvalue']
        };
        options.messages['mandatoryif'] = options.message;
    });

$.validator.addMethod('date',
    function (value, element) {
        return this.optional(element) || /^\d{4}[\/-]\d{2}[\/-]\d{2}\s*(?:\d{2}:\d{2}(?::\d{2})?)?$/.test(value);
    });

